<template>
  <div class="card-list" v-if="appointments.length">
    <h2 class="page-title home__requests-title">Atendimentos</h2>
    <article
      v-for="appointment in appointments"
      :key="appointment.id"
      class="card card--with-icon"
    >
      <div class="card-icon-wrap">
        <i class="material-icons">event</i>
      </div>
      <div class="card-content">
        <h3 class="card-title card-primary">
          {{ clientName(appointment.client) }}
        </h3>
        <p class="card-secondary card-meta">
          <i class="material-icons card-meta-icon">schedule</i>
          {{ formatDate(appointment.date) }}
        </p>
        <p class="card-meta">{{ serviceNames(appointment.services) }}</p>
        <span v-if="appointment.paid !== ''" class="card-badge">
          <i class="material-icons">check_circle</i>
          Pago {{ formatPaid(appointment) }}
        </span>
        <span v-if="appointment.clientConfirmedAt" class="card-badge">
          <i class="material-icons">done_all</i>
          Confirmado
        </span>
        <span v-if="appointment.clientCanceledAt" class="card-badge">
          <i class="material-icons">event_busy</i>
          Cancelado
        </span>
      </div>
      <div class="card-actions">
        <button
          type="button"
          class="btn-icon"
          aria-label="Editar"
          @click="$emit('edit', appointment.id)"
        >
          <i class="material-icons">edit</i>
        </button>
        <button
          type="button"
          class="btn-icon btn-icon-danger"
          aria-label="Excluir"
          @click="$emit('delete', appointment.id)"
        >
          <i class="material-icons">delete_outline</i>
        </button>
      </div>
    </article>
  </div>
</template>

<script>
import { useAppointmentStore } from '@/stores/appointment';

export default {
  name: 'AppointmentList',
  props: {
    appointments: { type: Array, required: true },
    clientName: { type: Function, required: true },
    serviceNames: { type: Function, required: true },
  },
  emits: ['edit', 'delete'],
  setup() {
    const appointmentStore = useAppointmentStore();
    return { appointmentStore };
  },
  methods: {
    formatDate(date) {
      return new Date(date).toLocaleString('pt-BR').substring(0, 17);
    },
    formatPaid(appointment) {
      return this.appointmentStore.getPaid(appointment).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
    },
  },
};
</script>

